import {DocumentNode, gql} from "@apollo/client";

export const REJECT_PAYOUT_MUTATION: DocumentNode = gql(`
    mutation RejectPayoutOperation($dto: RejectPayoutRequest!) {
        rejectPayoutOperation(rejectPayoutOperationsDTO: $dto) {
            message
        }
    }
`);
